import { Fragment } from 'react';
import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { useLanguageSwitcher, Language, localeConfig } from 'shared/domains/languages';
import { getCurrentMarket } from 'shared/domains/markets/config';
import { useAccount } from 'shared/domains/users';
import { FlagAvatar } from './styled';
export function LanguageSelector() {
    const account = useAccount();
    const { update } = useLanguageSwitcher();
    const { marketLocales } = getCurrentMarket();
    const currentLocale = localeConfig.getActiveLocale();
    const { userId } = account.data || {};
    const marketLocalesExceptCurrentLocale = marketLocales;
    return (<Fragment>
      <Menu.Label>
        <Trans comment="User menu: languages list header text">Languages</Trans>
      </Menu.Label>
      {marketLocalesExceptCurrentLocale.map(({ code, languageCode }) => {
            const { flag: FlagGlyph } = localeConfig.getLocale({ languageCode });
            return (<Menu.Item key={code} onClick={() => update({ locale: code, userId: userId || '' })} selected={currentLocale.code === code}>
            <FlagAvatar>
              <FlagGlyph />
            </FlagAvatar>
            <Language code={code} textInLocalLanguage/>
          </Menu.Item>);
        })}
    </Fragment>);
}
